import { List } from 'immutable';
import { STATES_PATHS } from '../../constants/StateConstants';
export const ROOT_PATH = '/';
export const ROOT_KB_PATH = '/:knowledgeBaseId(\\d+)';
export const KB_ONBOARDING_PATH = '/onboarding';
export const ARTICLES_ROUTE = `${ROOT_KB_PATH}/articles`;
export const ARTICLES_STATE_ROUTE = `${ARTICLES_ROUTE}/state`;
export const ARTICLES_STATE_ROUTE_WITH_PARAM = `${ARTICLES_STATE_ROUTE}/:state(${STATES_PATHS.join('|')})`;
export const CHANGE_ROUTES_ACTION = List.of('replace', 'push');
export const CHOOSE_TEMPLATE_ROUTE = `${ROOT_KB_PATH}/choose-template`;
export const INSIGHTS_ROUTE = `${ROOT_KB_PATH}/insights`;
export const INSIGHTS_DASHBOARD_ROUTE = `${INSIGHTS_ROUTE}/dashboard`;
export const INSIGHTS_ARTICLE_ROUTE = `/insights/article/:articleId`;
export const INSIGHTS_ARTICLE_PATH = `/insights/article`;
export const INSIGHTS_ARTICLE_PERFORMANCE_ROUTE = `${INSIGHTS_ARTICLE_ROUTE}/performance`;
export const ARTICLE_PUBLISHED_PATH = `published`;
export const INSIGHTS_ARTICLE_PUBLISHED_ROUTE = `${INSIGHTS_ARTICLE_ROUTE}/${ARTICLE_PUBLISHED_PATH}`;
export const ORGANIZE_ROUTE = `${ROOT_KB_PATH}/organize`;
export const ARTICLE_ROUTE = `${ROOT_KB_PATH}/article/:articleId`;
export const EDIT_PATH = `/edit`;
export const EDIT_ARTICLE_ROUTE = `${EDIT_PATH}/:articleId`;
export const TEMPLATE_EDITOR_ROUTE = `${ROOT_KB_PATH}/customize-template`;
export const TEMPLATE_EDITOR_CONTENT_ROUTE = `${TEMPLATE_EDITOR_ROUTE}/content`;
export const TEMPLATE_EDITOR_STYLES_ROUTE = `${TEMPLATE_EDITOR_ROUTE}/design`;
export const TEMPLATE_TRANSLATE_MODAL_ROUTE = `${TEMPLATE_EDITOR_ROUTE}/translate`;
export const SUGGESTIONS_ROUTE = `${ROOT_KB_PATH}/agent`;